import * as grpcWeb from '@improbable-eng/grpc-web';
import {
	OnboardingStatusMap,
	SetUserFontendParametersReply,
	SetUserFontendParametersRequest
} from '@aymeric_henry_sr/svelte-proto/profile_pb';
import {
	Profile,
	ProfileSetUserFontendParameters
} from '@aymeric_henry_sr/svelte-proto/profile_pb_service';
import { GRPC_HOST } from '../../constants/env.constants';
import { unaryTransport } from '../transport';
import { grpcError } from '$lib/utils/grpcError';
const { grpc } = grpcWeb;

export type ProfileSettings = {
	hasFinishedOnboarding: OnboardingStatusMap[keyof OnboardingStatusMap];
	hasCompletedSuspiciousActivityCheck: boolean;
};

export function setProfileSetting<T extends keyof ProfileSettings = keyof ProfileSettings>(
	setting: T,
	value: ProfileSettings[T]
) {
	return new Promise<{ status: grpcWeb.grpc.Code; message: SetUserFontendParametersReply }>(
		(resolve, reject) => {
			const req = new SetUserFontendParametersRequest();
			if (setting === 'hasFinishedOnboarding') {
				req.setHasfinishedonboarding(value as ProfileSettings['hasFinishedOnboarding']);
			}
			if (setting === 'hasCompletedSuspiciousActivityCheck') {
				req.setHascompletedsuspiciousactivitycheck(
					value as ProfileSettings['hasCompletedSuspiciousActivityCheck']
				);
			}
			grpc.unary<
				SetUserFontendParametersRequest,
				SetUserFontendParametersReply,
				ProfileSetUserFontendParameters
			>(Profile.SetUserFontendParameters, {
				request: req,
				host: GRPC_HOST,
				transport: unaryTransport,
				onEnd: (res) => {
					const { status, message } = res;
					if (status === grpc.Code.OK && message !== null) {
						resolve({
							status,
							message
						});
					}
					reject(grpcError(`setProfileSetting ${setting}`, arguments, res));
				}
			});
		}
	);
}
